<template>
  <div class="main-computer">
    <main>
      <header>
        <h3>计算机管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button @click="messageVisible = true"  style="margin-right: 15px"  :disabled="this.selectedComputerRowKeys.length>0 ? false:true"  v-if="$IA('system:process:changeVersionBatch')">
            <img src="../assets/images/task_upgradation.png" alt=""  style="padding-bottom:3px;">
          </a-button>
          <a-button v-if="$IA('system:machine:save')" type="primary" icon="plus" @click="handleOpen('添加')">添加</a-button>
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText">
            <a-input-search v-model.trim="pagination.searchText" placeholder="计算机"
                            style="width: 200px; " allow-clear :loading="btnLoad" @input="searchTextChange"
                            @search="searchChange" />
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-tree-select
                v-model='pagination.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                style="width: 180px; "
                @change="searchChange"
                show-search
                :filterTreeNode="filter_tree_node"
                placeholder="选择部门"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <!--          <a-form-model-item prop="type">-->
          <!--            <a-select v-model="pagination.type" placeholder="类型" style="width: 180px; " allowClear-->
          <!--                      :loading="btnLoad" @change="searchChange">-->
          <!--              <a-select-option :value="0">标准</a-select-option>-->
          <!--            </a-select>-->
          <!--          </a-form-model-item>-->
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>

        </a-form-model>
      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered  :data-source="tableData" :pagination="queryCondition" :loading="btnLoad"
               @change="handleTableChange" :scroll="{ y: 560 }"  rowKey="id" :rowSelection='rowComputerSelection'>

        <template slot="name" slot-scope="text, record">
          <img :src="
            record.needUpdate == 0
              ? null
              : require('../assets/images/update.png')
          " alt="" class="img-lc" />
          <span :title="text"> {{ text }}</span>
        </template>


        <template slot="type" slot-scope="text">
          <span v-if="text === '0'">
            <a-tag color="blue">标准</a-tag>
          </span>

        </template>
        <template slot="version" slot-scope="text">
          <img src="../assets/images/versions.png" class="img-lc" alt="" v-if="text" />
          <span :title="text">{{ text ?text:"未知" }}</span>
        </template>
        <span slot="action" slot-scope="record" class="table-action-box" >
            <a-tooltip  content="" title="查看" placement="top" effect="light">
              <i class="table-view" @click="handleOpen('查看', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:machine:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected" @click="handleOpen('删除', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" title="复制密钥" placement="top" effect="light">
            <i class="table-copy"  @click="copy('#computerId' +  record.machineKey)"  style="vertical-align: middle; margin-top: -3px;"></i>
                <input
                    style="position: absolute; z-index: -9;right: 20px;"
                    :id="'computerId' + record.machineKey"
                    :value="record.machineKey"
                />

            </a-tooltip>
        </span>
      </a-table>
    </main>

    <!-- 操作模态框 -->
    <a-modal centered :title="modalTitle + '计算机'" :visible="modalVisible" :confirm-loading="btnLoad" :maskClosable="false"
             @ok="handleOk('addForm')" @cancel="resetForm" :confirmLoading="submitLoad"
             :footer="modalTitle == '查看' ? null : undefined"  :width="modalTitle == '删除'? '420px' : '520px'">
      <a-form-model v-if="modalTitle == '添加'" layout="vertical" ref="addForm" :model="addForm" :rules="addFormRules">
        <a-form-model-item  prop="name">
          <template slot="label">
            计算机名称
            <a-tooltip  content="" placement="right" effect="light">
              <template slot="title">
                <span> 计算机名称须与robot所在计算机名称完全相同</span>
              </template>
              <i class="el-icon-warning" style="color: #3373f2;"></i>
            </a-tooltip>
          </template>
          <a-input v-model="addForm.name" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="类型" prop="type">
          <a-select v-model="addForm.type" placeholder="请选择">
            <a-select-option :value="0">标准</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="部门" prop="orgId">
          <a-select v-model="addForm.orgId" placeholder="请选择" show-search  :filter-option="filterOption">
            <a-select-option v-for="v in orgList" :key="v.id" :value="v.id">
              {{ v.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <a-descriptions v-if="modalTitle == '查看'" :column="1" bordered size="middle">
        <a-descriptions-item label="机器密钥">{{  this.singleDta.machineKey  }}
          <a-icon type="copy"  @click="copy('#computerId' +  singleDta.machineKey)" style="color: #007acc;margin-left:5px"/>
          <input
              style="position: absolute; z-index: -9;right: 20px;"
              :id="'computerId' + singleDta.machineKey"
              :value="singleDta.machineKey"
          /> </a-descriptions-item>
        <a-descriptions-item label="计算机名称">{{  this.singleDta.name  }}</a-descriptions-item>
        <a-descriptions-item label="类型">{{  this.singleDta.type == 0 ? '标准' : ''  }}</a-descriptions-item>
      </a-descriptions>

      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该计算机,是否继续?</p>
      </div>
    </a-modal>

    <!-- 升级 -->

    <a-modal :visible="messageVisible" width="450px" :closable="false" @cancel="messageVisible = false" class="message-modal" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="messageVisible = false">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="submitLoad" @click="upgradationClick">
          确定
        </a-button>
      </template>
      <p style="padding:40px 20px 20px;margin-bottom:0px;font-weight:600;font-size: 16px;">  <a-icon type="exclamation-circle" style="color: #ff7d00;margin-right: 10px;font-size: 20px" theme="filled" />请确认当前机器人上无正在执行的流程?</p>
    </a-modal>




  </div>
</template>

<script>
import {notification} from "ant-design-vue";
import useWS from "@/utils/websocket";

export default {
  computed: {
    rowComputerSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.computerSelectForm = []
          selectedRows.forEach((element) => {
            this.computerSelectForm.push({
              id : element.id,
              machineKey : element.machineKey,
            })
          });
          this.selectedComputerRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.needUpdate == 0,
          },
      }),
        selectedRowKeys: this.selectedComputerRowKeys,
      };
    },
  },
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      pagination: {
        searchText: '',
        pageSize: 10,
        current: 1,
        orgId:undefined,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      formLayout: "inline",
      queryCondition: {},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          ellipsis: true,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: '计算机名称',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: "name" },
        },
        {
          title: '部门',
          dataIndex: 'orgName',
          key: 'orgName',
          ellipsis: true,
        },
        {
          title: '类型',
          key: 'type',
          dataIndex: 'type',
          scopedSlots: { customRender: "type" },
        },
        {
          title: '机器人版本',
          key: 'version',
          dataIndex: 'version',
          ellipsis: true,
          scopedSlots: { customRender: "version" },
        },
        {
          title: '创建时间',
          key: 'createTime',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: '',
      // 单行数据
      singleDta: "",
      // 添加表单
      addForm: {
        name: '',
        orgId:undefined,
        type: 0,
      },
      // 是否按钮loading
      submitLoad: false,
      addFormRules: {
        name: [
          { required: true,  message: "计算机名称不能为空" },
          { max: 20, message: '最长不能超过20字符' }
        ],
        type: [{ required: true, message: '类型不能为空' }],
        orgId: [{ required: true, message: '部门不能为空' }],
      },
      // 分页参数
      pagCurrent:{},
      // 部门
      orgList:[],
      //部门下拉框
      treeData:[],
      // 启动流程
      startUpTaskVisible: false,
      // 提示框
      messageVisible: false,
      selectedComputerRowKeys:[],
      computerSelectForm:[]
    }
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 部门
    alltreeOrgList(){
      this.axios
          .post("/org/findOrg",'')
          .then((res) => {
            if (res.code === 200) {
              this.treeData = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 通知表格刷新
    handleJobWS(type,data){
      this.tableData.forEach((item)=>{
        if (item.id == data.id){
          item.version = data.version
        }
      })
    },
    // 搜索
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 重置表单通用方法
    resetForm() {
      if (this.modalTitle == '添加' || this.modalTitle == '修改') {
        this.$refs.addForm.resetFields()
      }
      this.modalVisible = false
    },
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title
      this.modalVisible = true
      this.singleDta = data

    },
    // 部门
    allorgList(){
      this.axios
          .post("/org/findParentOrg",)
          .then((res) => {
            if (res.code === 200) {
              this.orgList = res.data
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },

    // 流程一键升级
    upgradationClick(){
      this.messageVisible = true
      this.submitLoad = true
      this.axios
          .post('/machine/updateVersion', this.computerSelectForm)
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.handleTableChange(this.pagCurrent);
              this.messageVisible = false
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
    },
    
    
    
    // 确认模态框
    handleOk(formName) {
      switch (this.modalTitle) {
        case "添加":
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.submitLoad = true;
              let saveData = "";
              saveData = this.$lodash.cloneDeep(this.addForm);
              this.axios
                  .post("/machine/save", saveData)
                  .then((res) => {
                    this.submitLoad = false
                    if (res.code === 200) {
                      this.resetForm();
                      notification.success({
                        message: res.message,
                        duration: 3,
                        customClass: "batch-import",
                      })
                      this.handleTableChange(this.pagination);
                    }
                  })
                  .catch((err) => {
                    this.submitLoad = false
                    console.log(err);
                  });
            } else {
              console.log("error submit!!");
              return false;
            }
          });
          break;
        case "查看":
          break;
        case "删除":
          this.submitLoad = true;
          this.axios
              .delete("/machine/delete/" + this.singleDta.id)
              .then((res) => {
                this.submitLoad = false
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange(this.pagCurrent);
                  this.modalVisible = false;
                }
              })
              .catch((err) => {
                this.submitLoad = false
                console.log(err);
              });
          break;
      }
    },
    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 复制
    copy(domId) {
      document.querySelector(domId).select();
      try {
        if (window.clipboardData) {
          //清空操作系统粘贴板
          window.clipboardData.clearData();
          //将需要复制的内容复制到操作系统粘贴板
          window.clipboardData.setData("Text", document.querySelector(domId).value);
        } else {
          document.execCommand("copy");
        }
        this.$message.success("复制成功！请粘贴（Ctrl+V）使用");
      } catch (error) {
        console.log(error);
        this.$message.error("复制失败！请更换浏览器（Edge/Chrome）再次尝试");
      }
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true
      this.axios.post('/machine/findPage', this.$qs.stringify(this.queryCondition)).then((res) => {
        this.tableLoad = false
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.queryCondition.total = res.data.total;
        }
      }).catch((err) => {
        console.log(err);
        this.tableLoad = false
      })
    },
  },
  beforeMount() {
    this.searchChange()
    this.allorgList()
    this.alltreeOrgList()
  },
  mounted() {
    useWS('JOB', '/admin/websocket/packageVersion:updateVersion', this.handleJobWS)
  }
}
</script>

<style lang="scss" scoped>
.main-computer {


  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;


    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }


    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;
          }
        }
      }
      .table-action-box{
        i{
          padding:0px ;
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }

    .img-lc {
      vertical-align: middle;
      margin-right: 5px;
      margin-top: -1px;
    }
  }
}
</style>